import { render, staticRenderFns } from "./ItemSent.vue?vue&type=template&id=46ab3ed4&scoped=true"
import script from "./ItemSent.vue?vue&type=script&lang=js"
export * from "./ItemSent.vue?vue&type=script&lang=js"
import style0 from "./ItemSent.vue?vue&type=style&index=0&id=46ab3ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab3ed4",
  null
  
)

export default component.exports